import videoSource from '../assets/videos/intro.mp4';

// Il video dell'intro viene scaricato una sola volta, come Blob, mentre i giocatori creano le squadre,
// e poi riprodotto da un URL blob: la cutscene parte subito anche con una rete lenta e non dipende
// dalle richieste a intervalli (Range) che il service worker e Safari gestiscono in modo delicato.
let blobUrl = null;
let pending = null;

/** URL blob del video se è già stato scaricato, altrimenti null */
export function getIntroVideoUrl() {
    return blobUrl;
}

/** Avvia (una sola volta) il download del video. Risolve con l'URL da usare nel tag video:
 * il blob se il download riesce, altrimenti l'URL originale del file (il browser lo scarica da sé).
 */
export function preloadIntroVideo() {
    if (blobUrl) return Promise.resolve(blobUrl);
    if (pending) return pending;
    pending = fetch(videoSource)
        .then((resp) => {
            if (!resp.ok) throw new Error('Download video fallito (' + resp.status + ')');
            return resp.blob();
        })
        .then((blob) => {
            const typed = blob.type === 'video/mp4' ? blob : new Blob([blob], { type: 'video/mp4' });
            blobUrl = URL.createObjectURL(typed);
            return blobUrl;
        })
        .catch(() => videoSource)
        .finally(() => {
            pending = null;
        });
    return pending;
}
